import fetch from 'isomorphic-fetch';
import Config from 'Config';
import { getDefaultRequestHeaders } from '../../common/middleware/api';

export const WARNING_MESSAGES_REQUEST = 'WARNING_MESSAGES_REQUEST';
export const WARNING_MESSAGES_SUCCESS = 'WARNING_MESSAGES_SUCCESS';
export const WARNING_MESSAGES_FAILURE = 'WARNING_MESSAGES_FAILURE';

const WARNING_MESSAGES_URL = `${Config.frontofficeApiUrl}/api/warningMessages`;

const requestWarningMessages = () => ({
	type: WARNING_MESSAGES_REQUEST
});

const receiveWarningMessages = (json) => ({
	type: WARNING_MESSAGES_SUCCESS,
	payload: json
});

const warningMessagesError = () => ({
	type: WARNING_MESSAGES_FAILURE
});

export const loadWarningMessages = () => (dispatch, getState) => {
	dispatch(requestWarningMessages());
	const config = {
		headers: getDefaultRequestHeaders(getState())
	};
	return fetch(WARNING_MESSAGES_URL, config)
		.then(response => response.json().then(json => {
			if (!response.ok) {
				dispatch(warningMessagesError());
			} else {
				dispatch(receiveWarningMessages(json));
			}
		}));
};